<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" :md="dynamicCol">
                <v-card>
                    <v-card-title>
                        <h4>Liste des options en rapport avec l'organe de contrôle et de Regulation </h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-virtual-scroll :items="items" :item-height="50" height="400">
                        <template v-slot="{item}">
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon large>mdi-circle-small</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.libelle}}</v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn @click="openOption(item)" depressed small>
                                        Ouvrir
                                        <v-icon color="orange darken-4" right>mdi-eye</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-virtual-scroll>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {

    data: () => ({
        dynamicCol: 12,
        items:[
        {
            id: 1,
            libelle: 'Plans de Passation des Marchés (PPM)',
            routeName: 'ano_ppm_ac'
        },
        {
            id: 2,
            libelle: 'Avis d\'appel à concurrence',
            routeName: 'envoi_avis_ac'
        },
        {
            id: 3,
            libelle: 'Dossiers d\'appel à concurrence',
            routeName: 'ano_dossier_ac'
        },
        // {
        //     id: 4,
        //     libelle: 'Invitation à la séance d\'ouverture / d\'évaluation',
        //     routeName: 'seance_ac'
        // },
        // {
        //     id: 5,
        //     libelle: 'Envoi des rapports et PV',
        //     routeName: 'rapports'
        // }
    ],
    }),

    created() {
        this.$store.dispatch("Auth/getAllConfigHome");
        let Virt = [];

        Virt = JSON.parse(localStorage.getItem("userData"));
        this.profile = Virt.profile.status;
        this.user_data = Virt;
    },

    methods: {
        openOption(item) {
        if (item.routeName) {
            this.$router.push({ name: item.routeName });
        } else {
            console.error("Le nom de la route n'est pas défini pour cette option.");
        }
    }
    }
};

</script>

<style>
.w-62em {
    height: 62em !important;
    width: 100% !important;
}

.v-card__text {
    width: 100% !important;
}

.vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
}
</style>